'use client';

import UnstyledAccordion from '@/components/UnstyledAccordion';
import { PropsWithChildren } from 'react';

const FaqCardAccordion = ({ children }: PropsWithChildren) => {
  return <UnstyledAccordion>{children}</UnstyledAccordion>;
};

export default FaqCardAccordion;
